export default __webpack_public_path__ + "static/media/transland-trucks-3.be14b19e.jpg";